import { Outlet, ScrollRestoration, useLocation, useNavigate } from "react-router-dom";
import { Alert, Box, Toolbar, Container, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { RATE_LIMIT_EVENT, RATE_LIMIT_MESSAGE } from "../../utils/api";
import { useAuth } from "../../hooks/useAuth";

const RootLayout = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { sessionExpired } = useAuth();
  const [rateLimited, setRateLimited] = useState(false);

  useEffect(() => {
    if (sessionExpired) navigate("/admin-login?reason=session-expired", { replace: true });
  }, [navigate, sessionExpired]);

  useEffect(() => {
    const showRateLimitMessage = () => setRateLimited(true);
    window.addEventListener(RATE_LIMIT_EVENT, showRateLimitMessage);
    return () => window.removeEventListener(RATE_LIMIT_EVENT, showRateLimitMessage);
  }, []);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <NavBar />
      <Toolbar />
      <Box flexGrow={1}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Outlet />
        </Container>
      </Box>
      <Snackbar open={rateLimited} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="warning" onClose={() => setRateLimited(false)} sx={{ maxWidth: "calc(100vw - 32px)" }}>
          {RATE_LIMIT_MESSAGE}
        </Alert>
      </Snackbar>
      <Footer />
      <ScrollRestoration />
    </Box>
  );
};

export default RootLayout;
